import React from 'react';
import { Button, Card, CardContent, Grid, Slider, Stack, Typography } from '@mui/material';
import ScienceIcon from '@mui/icons-material/Science';
import { FDataGrid } from '../grid';
import { GridColDef } from '@mui/x-data-grid';

type Props = { rows: any[]; loading?: boolean; onRun: (records: any[]) => void };
type State = { controls: any[] };

class SimulationSensitivityPanel extends React.Component<Props, State> {
  state: State = { controls: [
    { code: 'BRENT', name: 'Brent Price', percent: 0, min: -20, max: 20, step: 1 },
    { code: 'FX', name: 'Exchange Rate', percent: 0, min: -15, max: 15, step: 1 },
    { code: 'INFLATION', name: 'Inflation', percent: 0, min: -10, max: 10, step: 0.5 },
  ]};

  columns: GridColDef[] = [
    { field: 'drivercode', headerName: 'Variable', width: 160 },
    { field: 'changepercent', headerName: 'Change %', width: 120, type: 'number' },
    { field: 'partialresultimpact', headerName: 'Partial Result Impact', width: 180, type: 'number' },
    { field: 'capacityimpact', headerName: 'Capacity Impact', width: 160, type: 'number' },
    { field: 'interpretation', headerName: 'Interpretation', flex: 1, minWidth: 260 },
  ];

  setControl = (code: string, percent: number) => this.setState({ controls: this.state.controls.map((x) => x.code === code ? { ...x, percent } : x) });

  renderControl(c: any) {
    return <Grid size={{ xs: 12, md: 4 }} key={c.code}><Card elevation={1}><CardContent><Stack spacing={1}><Typography variant="subtitle2" sx={{ fontWeight: 800 }}>{c.name}</Typography><Typography variant="h6">{c.percent}%</Typography><Slider value={c.percent} min={c.min} max={c.max} step={c.step} onChange={(_, v) => this.setControl(c.code, Number(v))} sx={{ height: 9 }} /></Stack></CardContent></Card></Grid>;
  }

  getRowId = (r: any) => `${r.drivercode}-${r.changepercent}`;

  render() {
    return (
      <Stack spacing={2}>
        <Grid container spacing={2}>{this.state.controls.map((c) => this.renderControl(c))}</Grid>
        <Button variant="contained" startIcon={<ScienceIcon />} onClick={() => this.props.onRun(this.state.controls)} disabled={this.props.loading}>Run Sensitivity</Button>
        <FDataGrid title="Sensitivity Results" subtitle="External/environmental what-if impact analysis." rows={this.props.rows || []} columns={this.columns} loading={this.props.loading} height={420} showQuickFilter toolbarSx={{ backgroundColor: '#eaf2fb' }} getRowId={this.getRowId} pageSizeOptions={[10, 25, 50]} />
      </Stack>
    );
  }
}
export default SimulationSensitivityPanel;
